import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { AUTOCOMPLETE_MAX_ITEMS } from '../../utils/constants';
import { CancelToken } from 'axios';
import { EntityState } from '@api/models/enums/EntityState';
import { TrainingDto } from '@api/models/training/TrainingDto';
import { trainingService } from '@api/services/services';

type State = BaseType<TrainingDto[]>;

const initialState: State = {
  state: FetchState.None,
  data: [],
};

export const optionsTrainingSlice = baseSlice({
  name: 'optionsTraining',
  initialState,
});

export const selectOptionsTrainingState = (state: RootState) => state.optionsTraining.state;
export const selectOptionsTraining = (state: RootState) => state.optionsTraining.data;
export const optionsTrainingActions = optionsTrainingSlice.actions;

export const getOptionsTraining =
  (search: string | undefined, skipId: string | undefined, cancelToken: CancelToken, ignoreWithoutQuestionnaireWithLanguage?: boolean) =>
  (dispatch: AppDispatch) => {
    const handleGetData = async () => {
      const response = await trainingService.query(
        {
          q: search,
          skipId: skipId,
          state: EntityState.Active,
          nameOnly: true,
          ignoreWithoutQuestionnaireWithLanguage: ignoreWithoutQuestionnaireWithLanguage,
          page: 0,
          size: AUTOCOMPLETE_MAX_ITEMS,
          sort: ['name', 'asc'],
        },
        { cancelToken: cancelToken },
      );
      return { data: response.data.content ?? [] };
    };

    getItem({
      dispatch,
      actions: optionsTrainingActions,
      getData: handleGetData,
    });
  };
